<template>
    <!-- <Footer1 v-if="getFooterSettings.footer_type === 'type1'" v-bind:data="getFooterSettings" /> -->
    <!-- <Footer2 v-else-if="getFooterSettings.footer_type === 'type2'" v-bind:data="getFooterSettings" /> -->
    <Footer3 v-bind:data="getFooterSettings" />
</template>

<script>
    // import Footer1 from './type1/Footer.vue';
    // import Footer2 from './type2/Footer.vue';
    import Footer3 from './type3/Footer.vue';
    import { mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'Footers',
        components: {
            // Footer1,
            // Footer2,
            Footer3,
        },
        mounted() {
            this.__getFooterSettings();
        },
        data: () => ({}),
        computed: {
            ...mapGetters('app', [
                'getHeaderSettings', //
                'getFooterSettings',
            ]),
        },
        methods: {
            ...mapMutations('app', [
                'setHeaderSettings', //
                'setFooterSettings',
            ]),

            async __getFooterSettings() {
                const res = await this.call_api('get', `setting/footer`);
                if (res.status === 200) {
                    this.setFooterSettings(res.data);
                }
            },
        },
    };
</script>
